// src/redux/slices/Map/map.jsx
import { createSlice } from '@reduxjs/toolkit'
import {
  loadTreeCodeLabelsEnabled,
  saveTreeCodeLabelsEnabled,
} from '../../../utils/treeCodeLabelsStorage'

export const mapState = createSlice({
  name: 'mapState',
  // Inicializador perezoso: lee la preferencia de sesión al crear el store.
  initialState: () => ({
    style: {
      type: {
        standard: { id: 'standard', label: 'Estandar' },
        standard_satellite: { id: 'standard-satellite', label: 'Satélite' },
      },
      current: 'standard',
    },
    satelliteEnabled: false,
    satelliteLoading: false,
    pointsOnlyMode: false,
    treeCodeLabelsEnabled: loadTreeCodeLabelsEnabled(),
    lightPreset: {
      enabled: true,
      current: 'day',
    },
    popup: {
      open: false,
      code: null,
      id: null,
      loading: false,
    },
    currentTreeId: null,
    coords: null,
    addMode: false,
    showAccessAlert: false,
    showTenantAlert: false,
    mapExpanded: false,
  }),
  reducers: {
    changeMapStyle: (state, action) => {
      state.style.current = action.payload
      const isStandard =
        action.payload === 'standard' || action.payload === 'standard-satellite'
      state.lightPreset.enabled = isStandard
    },
    changeLightPreset: (state, action) => {
      state.lightPreset.current = action.payload
    },
    changePopup: (state, action) => {
      state.popup.open = action.payload
    },
    setPopup: (state, action) => {
      state.popup = { loading: false, ...action.payload }
    },
    setPopupLoading: (state, action) => {
      state.popup.loading = action.payload
    },
    setCurrentTreeId: (state, action) => {
      state.currentTreeId = action.payload
    },
    setTreeCoords: (state, action) => {
      state.coords = action.payload
    },
    setAddMode: (state, action) => {
      state.addMode = action.payload
    },
    setSatelliteEnabled: (state, action) => {
      state.satelliteEnabled = action.payload
      // Activar loading en el mismo tick que el click; desactivar al apagar
      state.satelliteLoading = Boolean(action.payload)
    },
    setSatelliteLoading: (state, action) => {
      state.satelliteLoading = action.payload
    },
    setPointsOnlyMode: (state, action) => {
      state.pointsOnlyMode = action.payload
    },
    setTreeCodeLabelsEnabled: (state, action) => {
      state.treeCodeLabelsEnabled = action.payload
    },
    setShowAccessAlert: (state, action) => {
      state.showAccessAlert = action.payload
    },
    setShowTenantAlert: (state, action) => {
      state.showTenantAlert = action.payload
    },
    setMapExpanded: (state, action) => {
      state.mapExpanded = action.payload
    },
  },
})

export const {
  changeMapStyle,
  changeLightPreset,
  changePopup,
  setCurrentTreeId,
  setPopup,
  setPopupLoading,
  setTreeCoords,
  setAddMode,
  setSatelliteEnabled,
  setSatelliteLoading,
  setPointsOnlyMode,
  setTreeCodeLabelsEnabled,
  setShowAccessAlert,
  setShowTenantAlert,
  setMapExpanded,
} = mapState.actions

// Alterna los códigos de árbol y recuerda la elección durante la sesión.
export const toggleTreeCodeLabels = () => (dispatch, getState) => {
  const treeCodeLabelsEnabled = !getState().mapState.treeCodeLabelsEnabled
  saveTreeCodeLabelsEnabled(treeCodeLabelsEnabled)
  dispatch(setTreeCodeLabelsEnabled(treeCodeLabelsEnabled))
}

export default mapState.reducer
